import React from 'react';
import EditVehicleModelComponent from '../../../Components/VehicleModel/EditVehicleModel';

export default function EditVehicleModel() {
    return (
        <div className='page-body'>
            <EditVehicleModelComponent />
        </div>
    );
}